















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Footer extends Vue {
  private dateEnd: Number = new Date().getFullYear();
}
